import { TrustLabelPeriod } from '../../../../../components-library/labels/TrustLabel';

export default {
  labels: {
    [TrustLabelPeriod.LESS_THAN_1_MONTH]: 'Mais de 100 clientes já encomendaram em segurança connosco',
    [TrustLabelPeriod.ONE_MONTH_OR_MORE]: 'Mais de 1.000 clientes já encomendaram em segurança connosco',
    [TrustLabelPeriod.SIX_MONTHS_OR_MORE]: 'Mais de 10.000 clientes já encomendaram em segurança connosco',
  },
};
